import { actionTypes } from "../actions/action_types";

import store from "../index";

export const appendKeycloakDetails = data => dispatch => {
  return dispatch({
    type: actionTypes.APPEND_KEYCLOAK_DETAILS,
    payload: data
  });
};

export const accountLogout = () => dispatch => {
  return dispatch({
    type: actionTypes.ACCOUNT_LOGOUT
  });
};

export const accountLoginFailed = data => () => {
  return store.dispatch({
    type: actionTypes.LOGIN_FAILED,
    payload: data
  });
};
